import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthBackendService } from '../../../auth/service/auth-backend.service';


@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: [
    './maintenance.component.scss',
    '../entrance-group.scss',
  ],
})
export class MaintenanceComponent implements OnInit {
  title = 'The website is being updated';
  subTitle = 'We’re currently working on the website to make it even better. Should not take long, so try login again a bit later.';
  constructor(
    private router: Router,
    private authService: AuthBackendService) {
  }

  ngOnInit(): void {
    this.authService.getMaintenance().then((isMaintenance) => {
      if (!isMaintenance) {
        this.back();
      }
    });
  }

  back(): void {
    this.router.navigate(['/login']);
  }
}
